/**
 * Set of `accountType` strings already taken by other self-funding sources.
 * Used to disable already-selected types in the asset-type dropdown.
 *
 * Excludes:
 *   - the source currently being edited (so its type stays selectable)
 *   - sources shared from the partner (the recipient doesn't own them, so they
 *     can still add their own account of the same type)
 */
export function deriveUsedAccountTypes({
  selfFunding,
  currentFundingSourceId,
  partnerSharedFundingSourceIds,
}: {
  selfFunding: Record<string, SelfFundingSource>;
  currentFundingSourceId: string | undefined;
  partnerSharedFundingSourceIds: Set<string>;
}): Set<string> {
  const used = new Set<string>();
  Object.entries(selfFunding).forEach(([id, source]) => {
    if (id === currentFundingSourceId) return;
    if (partnerSharedFundingSourceIds.has(id)) return;
    if (source.accountType) used.add(source.accountType);
  });
  return used;
}
